/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import LeadPropertyModal from './LeadPropertyModal'
import {getListLead, leadStats, leadStatusUpdate} from '../LeadManagementAPI'
import Swal from 'sweetalert2'
import AddPropertyForLead from './AddPropertyForLead'
import {dashboardStateDataType, leadListDataType} from '../LeadManagementDataTypes'
import {CircularProgress} from '@mui/material'
import styles from '../LeadManagementStyles/LeadManagementStyle.module.scss'
import ViewLead from './ViewLead'
import LeadDetails from './LeadDetails'
import SearchProperty from '../../property/SearchProperty'
import PaginationComponent from '../../PaginationComponent/Pagination'

const LeadManagementDashboard = ({leadFormLink}: {leadFormLink: string | undefined}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [isCopied, setIsCopied] = useState<boolean>(false)
  const [showPropertyModal, setShowPropertyModal] = useState<string | null>(null)
  const [showAddPropertyForLeads, setShowAddPropertyForLeads] = useState<string | null>(null)
  const [typeOfModal, setTypeOfModal] = useState<string>('')
  const [leadList, setLeadList] = useState<leadListDataType>()
  const [dashboardStats, setDashboardStats] = useState<dashboardStateDataType>()
  const [noDataFound, setNoDataFound] = useState<boolean>(false)
  const [showLeadDetails, setShowLeadDetails] = useState<string | null>(null)
  const [searchInputValue, setsearchInputValue] = useState<string>('')
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [dataLength, setDataLength] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  // function to get list for the leads
  const getLeadList = async () => {
    setLoading(true)
    try {
      const {data: response} = await getListLead(itemOffset, itemsPerPage, searchInputValue)
      if (response.code === '200') {
        setLeadList(response.data)
        setDataLength(response.data.totalLeads)
        setNoDataFound(false)
      } else if (response.code === '204') {
        setNoDataFound(true)
        setLeadList(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }

  // function to get dashboard stats for leads management
  const getDashboardStats = async () => {
    try {
      const {data: response} = await leadStats()
      if (response.code === '200') {
        setDashboardStats(response.data)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }

  // onload fetch list leads and dashboard stats
  useEffect(() => {
    // setLoading(true)
    getLeadList()
    // const fetchData = async () => {
    //   try {
    //     await Promise.all([getLeadList(), getDashboardStats()])
    //   } catch (error: any) {
    //     Swal.fire({
    //       position: 'center',
    //       icon: 'error',
    //       title: error,
    //     })
    //   } finally {
    //     setLoading(false)
    //   }
    // }
    // fetchData()
  }, [itemOffset, searchInputValue])

  // function to copy the leads form link to the clipboard
  const copyToClipboard = () => {
    if (leadFormLink) {
      navigator.clipboard
        .writeText(leadFormLink)
        .then(() => {
          setIsCopied(true)
          // Reset the 'Copied' state after a few seconds
          setTimeout(() => {
            setIsCopied(false)
          }, 3000)
        })
        .catch((error) => {
          console.error('Failed to copy:', error)
        })
    }
  }

  // function to color the status based on the status code
  const returnStatusColor = (val: any) => {
    switch (val) {
      // for Added
      case 'Lead Submitted':
        return 'badge-light-primary'
      case 'Properties Proposed':
        return 'badge-light-info'
      case 'Property Accepted':
        return 'badge-light-success'
      case 'Details Submitted':
        return `${styles.status_processing}`
      case 'Booking Amount Paid':
        return `${styles.status_payment_done}`
      default:
        return 'badge-light-primary'
    }
  }

  // function to handle the status for the leads
  const handleStatusChange = async (val: string, leads_data_uuid: string) => {
    try {
      const {data: response} = await leadStatusUpdate(leads_data_uuid, parseInt(val, 10))
      if (response.code === '200') {
        getLeadList()
        // getDashboardStats()
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  const returnStatus = (status: number, statusMsg: string, properties: any) => {
    if (status === 6 || status === 7) {
      return statusMsg
    } else {
      const hasAccepted = properties.filter((item: any) => item.leads_property_status === 1)
      if (properties.length > 0 && hasAccepted.length > 0) {
        return 'Property Accepted'
      } else if (properties.length > 0) {
        return 'Properties Proposed'
      } else if (properties.length === 0) {
        return 'Lead Submitted'
      }
    }
  }
  const deleteLead = async (leads_data_uuid: string) => {
    Swal.fire({
      title: 'Are you sure that you want to delete lead?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const {data: response} = await leadStatusUpdate(leads_data_uuid, 5)
          if (response.code === '200') {
            getLeadList()
            // getDashboardStats()
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
              text: 'Lead deleted successfully',
              allowOutsideClick: true,
            })
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
              text: response.msg_details,
              allowOutsideClick: true,
            })
          }
        } catch (error: any) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: error,
          })
        }
      }
    })
  }
  return (
    <>
      <div>
        {/* Begin: Dashboard stats */}
        <div className='card mb-5 mb-xl-5'>
          <div className='card-body pt-9 pb-0'>
            <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  {/* Begin: Heading */}
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <div className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                        Lead Management
                      </div>
                    </div>
                  </div>
                  {/* End: Heading */}

                  {/* Begin: copy form link button */}
                  <div className='d-flex my-1 flex-wrap'>
                    <div className='me-5 mb-2'>
                      <SearchProperty
                        setCurrentPage={setCurrentPage}
                        setItemOffset={setItemOffset}
                        setsearchInputValue={setsearchInputValue}
                        placeholder='Lead'
                      />
                    </div>
                    {leadFormLink ? (
                      <button
                        onClick={copyToClipboard}
                        className='btn btn-sm btn-primary mb-2'
                        data-bs-toggle='modal'
                        data-bs-target='#kt_modal_offer_a_deal'
                      >
                        {isCopied ? (
                          <i className='bi bi-clipboard-check me-2 my-0 p-0 fs-5'></i>
                        ) : (
                          <i className='bi bi-clipboard me-2 my-0 p-0 fs-5'></i>
                        )}
                        <span>{isCopied ? 'Copied!' : 'Copy Form Link'}</span>
                      </button>
                    ) : (
                      <button
                        className='btn btn-sm btn-primary me-3 mb-2'
                        data-bs-toggle='modal'
                        data-bs-target='#kt_modal_offer_a_deal'
                      >
                        <span className='indicator-progress' style={{display: 'block'}}>
                          Loading...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      </button>
                    )}
                  </div>
                  {/* End: copy form link button */}
                </div>

                {/* Begin: stats cards */}
                {/* <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'> */}
                {/* Begin: Submitted card */}
                {/* <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{dashboardStats?.submitted}</div>
                          </div>
                          <div className='fw-bold fs-6 text-gray-400'>Submitted</div>
                        </div> */}
                {/* End: Submitted card */}
                {/* Begin: Acknowledged card */}
                {/* <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{dashboardStats?.acknowledged}</div>
                          </div>
                          <div className='fw-bold fs-6 text-gray-400'>Acknowledged</div>
                        </div> */}
                {/* End: Acknowledged card */}
                {/* Begin: Accepted card */}
                {/* <div className='border badge-light-success border-gray-300 border-dashed rounded min-w-150px max-w-200px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{dashboardStats?.accepted}</div>
                          </div>
                          <div className='fw-bold fs-6 text-gray-400'>Accepted</div>
                        </div> */}
                {/* End: Accepted card */}
                {/* Begin: In progress card */}
                {/* <div className='border badge-light-warning border-gray-300 border-dashed rounded min-w-150px max-w-200px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{dashboardStats?.inprogress}</div>
                          </div>
                          <div className='fw-bold fs-6 text-gray-400'>In progress</div>
                        </div> */}
                {/* End: In progress card */}
                {/* Begin: Rejected card */}
                {/* <div className='border badge-light-danger border-gray-300 border-dashed rounded max-w-200px min-w-150px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{dashboardStats?.rejected}</div>
                          </div>
                          <div className='fw-bold fs-6 text-gray-400'>Rejected</div>
                        </div> */}
                {/* End: Rejected card */}
                {/* </div>
                    </div>
                  </div> */}
                {/* End: stats cards */}
              </div>
            </div>
          </div>
        </div>
        {/* End: Dashboard stats */}

        {loading ? (
          // {* Begin: loader*}
          <div
            className='d-flex justify-content-center align-items-center vh-70'
            style={{height: '70vh'}}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            {/* Begin: Table */}
            <div id='table div'>
              <div className='card mb-5 mb-xl-8'>
                <div className='card-body py-3'>
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      {!noDataFound && (
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='max-w-150px'>Lead Name</th>
                            <th className='max-w-150px'>Contact Details</th>
                            {/* <th className='max-w-50px'>properties</th> */}
                            <th className='max-w-150px'>current status</th>
                            <th className='max-w-100px'>Actions</th>
                          </tr>
                        </thead>
                      )}
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {noDataFound ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  No leads present
                                </span>
                              </span>
                            </td>
                          </tr>
                        ) : (
                          <>
                            {leadList &&
                              leadList.leads?.map((lead, index) => {
                                return (
                                  <tr key={index}>
                                    <td className='max-w-150px'>
                                      <div className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {lead.full_name}
                                      </div>
                                    </td>
                                    <td className='max-w-150px'>
                                      <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                        {lead.mobile_number}
                                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                          {lead.email}
                                        </span>
                                      </div>
                                    </td>
                                    {/* <td className='max-w-100px cursor-pointer'>
                                    {showPropertyModal === lead.leads_data_uuid && (
                                      <>
                                        <LeadPropertyModal
                                          show={showPropertyModal}
                                          handleClose={() => setShowPropertyModal(null)}
                                          typeOfModal={typeOfModal}
                                          setTypeOfModal={setTypeOfModal}
                                          lead_property_details={lead.lead_property_details}
                                          getLeadList={getLeadList}
                                          returnStatusColor={returnStatusColor}
                                          property_visits_matched={lead.property_visits.matched}
                                        />
                                      </>
                                    )}

                                    <span
                                      onClick={() => {
                                        setShowPropertyModal(lead.leads_data_uuid)
                                        setTypeOfModal('Matched')
                                      }}
                                      className='badge badge-success fw-semibold me-5 mb-1'
                                    >
                                      {`${lead.property_visits.matched} Matched`}
                                    </span>
                                    {lead.property_visits.visited > 0 && (
                                      <span
                                        onClick={() => {
                                          setShowPropertyModal(lead.leads_data_uuid)
                                          setTypeOfModal('Visited')
                                        }}
                                        className='badge badge-info me-5 mb-1'
                                      >
                                        {`${lead.property_visits.visited} Visited`}
                                      </span>
                                    )}
                                    {lead.property_visits.scheduled > 0 && (
                                      <span
                                        onClick={() => {
                                          setShowPropertyModal(lead.leads_data_uuid)
                                          setTypeOfModal('Scheduled')
                                        }}
                                        className='badge badge-primary me-5 mb-1'
                                      >
                                        {`${lead.property_visits.scheduled} Scheduled`}
                                      </span>
                                    )}
                                  </td> */}
                                    <td className='max-w-150px'>
                                      <div
                                        className={`badge fw-semibold fs-7 ${returnStatusColor(
                                          returnStatus(
                                            lead.leads_data_status,
                                            lead.leads_data_status_msg,
                                            lead.lead_property_details
                                          )
                                        )}`}
                                      >
                                        {returnStatus(
                                          lead.leads_data_status,
                                          lead.leads_data_status_msg,
                                          lead.lead_property_details
                                        )}
                                      </div>
                                      {/* <select
                                      className={`form-select py-2 px-4 ${returnStatusColor(
                                        lead.leads_data_status
                                      )}`}
                                      name='leads_property_status'
                                      placeholder='Select status'
                                      onChange={(e) =>
                                        handleStatusChange(e.target.value, lead.leads_data_uuid)
                                      }
                                      value={lead.leads_data_status}
                                    >
                                      <option className='bg-color-gray text-dark' value=''>
                                        Select status
                                      </option>
                                      <option value='0' className='bg-color-white text-dark'>
                                        Submitted
                                      </option>
                                      <option value='1' className='bg-color-white text-dark'>
                                        Accepted
                                      </option>
                                      <option value='2' className='bg-color-white text-dark'>
                                        Acknowledged
                                      </option>
                                      <option value='3' className='bg-color-white text-dark'>
                                        In Progress
                                      </option>
                                      <option value='4' className='bg-color-white text-dark'>
                                        Rejected
                                      </option>
                                      <option value='5' className='bg-color-white text-dark'>
                                        Delete
                                      </option>
                                      <option value='6' className='bg-color-white text-dark'>
                                        Details Submitted
                                      </option>
                                      <option value='7' className='bg-color-white text-dark'>
                                        Booking Amount Paid
                                      </option>
                                    </select> */}
                                    </td>
                                    <td className='max-w-100px'>
                                      <div className='d-flex flex-shrink-0'>
                                        {/* {(lead.leads_data_status !== 6 && 
                                        lead.leads_data_status !== 7) && ( */}
                                        <button
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          onClick={() => setShowLeadDetails(lead.leads_data_uuid)}
                                        >
                                          <i
                                            className='bi bi-eye-fill bi-4x fs-3'
                                            title='View Lead'
                                          ></i>
                                        </button>
                                        <button
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          onClick={() =>
                                            setShowAddPropertyForLeads(lead.leads_data_uuid)
                                          }
                                        >
                                          <i
                                            className='bi bi-gear-fill bi-4x fs-3'
                                            title='Manage Lead'
                                          ></i>
                                        </button>
                                        <button
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          onClick={() => deleteLead(lead.leads_data_uuid)}
                                        >
                                          <i
                                            className='bi bi-trash-fill bi-4x fs-3'
                                            title='Delete Lead'
                                          ></i>
                                        </button>
                                        {/* )} */}
                                        {showAddPropertyForLeads === lead.leads_data_uuid && (
                                          // <AddPropertyForLead
                                          //   leads_data_uuid={lead.leads_data_uuid}
                                          //   lead_property_details={lead.lead_property_details}
                                          //   getLeadList={getLeadList}
                                          //   show={showAddPropertyForLeads}
                                          //   handleClose={() => setShowAddPropertyForLeads(null)}
                                          // />
                                          <ViewLead
                                            leads_data_uuid={lead.leads_data_uuid}
                                            lead_property_details={lead.lead_property_details}
                                            getLeadList={getLeadList}
                                            show={showAddPropertyForLeads}
                                            handleClose={() => setShowAddPropertyForLeads(null)}
                                            data={JSON.parse(lead.leads_json_data)}
                                          />
                                        )}
                                        {showLeadDetails === lead.leads_data_uuid && (
                                          <LeadDetails
                                            show={showLeadDetails}
                                            handleClose={() => setShowLeadDetails(null)}
                                            data={JSON.parse(lead.leads_json_data)}
                                          />
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                )
                              })}
                          </>
                        )}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                </div>
              </div>
            </div>
            {/* End: Table */}
            {/* Begin: Pagination */}
            {leadList && pageCount > 1 && (
              <PaginationComponent
                itemsPerPage={itemsPerPage}
                dataLength={dataLength}
                setItemOffset={setItemOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageCount={pageCount}
              />
            )}
            {/* End: Pagination */}
          </>
        )}
      </div>
    </>
  )
}

export default LeadManagementDashboard
